import { Injectable } from '@angular/core';
import { Common } from '@icc/shared/helpers';
import { isObject, isString } from '@icc/shared/helpers/b2b';
import { TranslateService } from '@icc/shared/translate.service';

@Injectable({
    providedIn: 'root',
})
export class PriceDictionaryService {

  constructor(
      private translateService: TranslateService
  ) {}

  dictionary = {
    accessories: this.translateService.instant('ACCESSORY|Akcesoria'),
    additionalLockCylinder: this.translateService.instant('DOOR|Rodzaj wkładki zamka dodatkowego'),
    additionalLockPlate: this.translateService.instant('DOOR|Typ szyldu zamka dodatkowego'),
    alignment: this.translateService.instant('WINDOW|Wyrównanie'),
    all: this.translateService.instant('INTERFACE|Wszystko'),
    alushell: this.translateService.instant('WINDOW|Nakładka alum.'),
    alushellPercent: this.translateService.instant('WINDOW|Nakładka alum. - dopł. procentowa'),
    amount: this.translateService.instant('DIMENSION|Rozmiar'),
    angles: this.translateService.instant('DIMENSION|Kąty'),
    area: this.translateService.instant('DIMENSION|Pow.'),
    bars: this.translateService.instant('WINDOW|Szprosy'),
    baseValue: this.translateService.instant('CONFIGURATOR|Wartość bazowa'),
    beadsPrice: this.translateService.instant('WINDOW|Dopłata za listwy przyszybowe'),
    bottom: this.translateService.instant('INTERFACE|Dół'),
    bottomSashesCount: this.translateService.instant('WINDOW|Liczba kwater u dołu'),
    box: this.translateService.instant('ROLLER_SHUTTER_LEGACY|Skrzynka'),
    boxPrice: this.translateService.instant('ROLLER_SHUTTER_LEGACY|Cena skrzynki'),
    cassonetto: this.translateService.instant('GOODS|Kasonetka'),
    categoryId: this.translateService.instant('CONFIGURATOR|Id kategorii'),
    cause: this.translateService.instant('WINDOW|Powód'),
    changedHandlesHeights: this.translateService.instant('WINDOW|Zmiany wysokości klamek'),
    handlePosition: this.translateService.instant('WINDOW|Zmiany pozycji klamek'),
    changedSize: this.translateService.instant('PLEATED_BLIND|Zmiana rozmiaru'),
    charge: this.translateService.instant('CONFIGURATOR|Dopłata'),
    chargeType: this.translateService.instant('CONFIGURATOR|Rodzaj dopłaty'),
    code: this.translateService.instant('WINDOW|Kod'),
    color: this.translateService.instant('COLOR|Kolor'),
    colorAlushell: this.translateService.instant('WINDOW|Kolor nakładki alum.'),
    colorField: this.translateService.instant('COLOR|Pole koloru'),
    colorGroup: this.translateService.instant('COLOR|Grupa koloru'),
    colorName: this.translateService.instant('COLOR|Nazwa koloru'),
    colorOut: this.translateService.instant('COLOR|Kolor zewn.'),
    colors: this.translateService.instant('COLOR|Kolory'),
    complementaryGoods: this.translateService.instant('GOODS|Dobra komplementarne'),
    constructionLimitations: this.translateService.instant('WINDOW|Ograniczenia konstrukcji'),
    constructSupp: this.translateService.instant('WINDOW|Rabat za wiele skrzydeł'),
    control: this.translateService.instant('GARAGE_DOOR|Napęd/mechanizm otwierania garażu'),
    count: this.translateService.instant('INTERFACE|Ilość'),
    coupledWindow: this.translateService.instant('COUPLED_WINDOW|Konstrukcja złożona'),
    couplings: this.translateService.instant('WINDOW|Łączniki'),
    data: this.translateService.instant('INTERFACE|Dane'),
    decorativeHingeCovers: this.translateService.instant('DOOR|Ozdobne nakładki zawiasów'),
    dividers: this.translateService.instant('WINDOW|Słupki/Poprzeczki'),
    dividersCross: this.translateService.instant('WINDOW|Łączenia szczeblin'),
    doorHandleAdjustment: this.translateService.instant('DOOR|Przystosowanie pod pochwyt'),
    doorModel: this.translateService.instant('DOOR|Model drzwi'),
    doorPortal: this.translateService.instant('DOOR|Portal'),
    portalLeftWidth: this.translateService.instant('DOOR|Szerokość portalu lewego'),
    portalRightWidth: this.translateService.instant('DOOR|Szerokość portalu prawego'),
    portalUpperHeight: this.translateService.instant('DOOR|Wysokość portalu górnego'),
    portalWallThickness: this.translateService.instant('DOOR|Szerokość muru'),
    doorSize: this.translateService.instant('DIMENSION|Rozmiar drzwi'),
    doorViewer: this.translateService.instant('DOOR|Wizjer'),
    outerDoor: this.translateService.instant('DOOR|Dopłata za drzwi otwierane na zewnątrz'),
    drive: this.translateService.instant('ROLLER_SHUTTER_LEGACY|Sterowanie'),
    driveElems: this.translateService.instant('ACCESSORY|Akcesoria do sterowania'),
    driveManual: this.translateService.instant('ROLLER_SHUTTER_LEGACY|Sterowanie ręczne'),
    duplex: this.translateService.instant('WINDOW|Dupleks'),
    electronicLock: this.translateService.instant('DOOR|Typ elektronicznej wkładki'),
    fabric: this.translateService.instant('AWNING|Materiał'),
    factor: this.translateService.instant('WINDOW|Współczynnik'),
    factorArea: this.translateService.instant('WINDOW|Współczynnik za pole'),
    fields: this.translateService.instant('WINDOW|Pola'),
    filling: this.translateService.instant('WINDOW|Wypełnienie'),
    fillingShape: this.translateService.instant('WINDOW|Kształt wypełnienia'),
    fitting: this.translateService.instant('WINDOW|Okucie bezp.'),
    fittings: this.translateService.instant('WINDOW|Okucia bezpieczne'),
    fittingsPercent: this.translateService.instant('WINDOW|Okucia bezpieczne (dopł. procentowa)'),
    frame: this.translateService.instant('WINDOW|Rama'),
    glass: this.translateService.instant('WINDOW|Szyba'),
    glassTypes: this.translateService.instant('WINDOW|Szyby'),
    glazingCount: this.translateService.instant('WINDOW|Liczba szyb'),
    glazingBeadColor: this.translateService.instant('WINDOW|Kolor listwy przyszybowej'),
    glazingPrice: this.translateService.instant('WINDOW|Cena za pakiet szybowy'),
    good: this.translateService.instant('GOODS|Dobro'),
    handles: this.translateService.instant('WINDOW|Klamki'),
    handlesHeights: this.translateService.instant('WINDOW|Wysokości klamek'),
    hardwareType: this.translateService.instant('DOOR|Typ osprzętu'),
    height: this.translateService.instant('DIMENSION|Wysokość'),
    hinge: this.translateService.instant('DOOR|Zawias'),
    id: this.translateService.instant('INTERFACE|ID'),
    idOuter: this.translateService.instant('INTERFACE|ID zewn.'),
    index: this.translateService.instant('INTERFACE|Indeks'),
    inscription: this.translateService.instant('AWNING|Napis na falbanie'),
    intMullions: this.translateService.instant(
        'WINDOW|Słupki/Poprzeczki/Szczebliny/Szprosy konstrukcyjne'
    ),
    isashId: this.translateService.instant('WINDOW|Nr pola'),
    kicker: this.translateService.instant('WINDOW|Kopacz'),
    left: this.translateService.instant('INTERFACE|Lewy'),
    length: this.translateService.instant('DIMENSION|Długość'),
    line: this.translateService.instant('CONFIGURATOR|Linia'),
    lock: this.translateService.instant('DOOR|Zamek'),
    lowThreshold: this.translateService.instant('WINDOW|Niski próg'),
    mainLockCylinder: this.translateService.instant('DOOR|Rodzaj wkładki zamka głównego'),
    mainLockPlate: this.translateService.instant('DOOR|Typ szyldu zamka głównego'),
    margin: this.translateService.instant('CONFIGURATOR|Marża'),
    market: this.translateService.instant('CONFIGURATOR|Rynek'),
    marketMargin: this.translateService.instant('CONFIGURATOR|Marża rynku'),
    montage: this.translateService.instant('CONFIGURATOR|Montaż'),
    mosquitoColor: this.translateService.instant('MOSQUITO|Kolor siatki'),
    mosquitoMontage: this.translateService.instant('MOSQUITO|Montaż siatki'),
    mosquitoProfile: this.translateService.instant('MOSQUITO|Profil siatki'),
    mosquitoSize: this.translateService.instant('MOSQUITO|Rozmiar siatki'),
    mounting: this.translateService.instant('AWNING|Sposób montażu markizy'),
    multiSash: this.translateService.instant('WINDOW|Konstr. wieloskrzydłowa'),
    muntins: this.translateService.instant('WINDOW|Szprosy'),
    name: this.translateService.instant('INTERFACE|Nazwa'),
    nameOuter: this.translateService.instant('INTERFACE|Nazwa zewn.'),
    outerColorName: this.translateService.instant('COLOR|Nazwa koloru zewn.'),
    outreach: this.translateService.instant('AWNING|Wysięg'),
    overlay: this.translateService.instant('WINDOW|Nakładka'),
    overload: this.translateService.instant('ROLLER_SHUTTER_LEGACY|Przeciążenie'),
    overRuCount: this.translateService.instant('WINDOW|Liczba skrzydeł RU'),
    oversize: this.translateService.instant('WINDOW|Ponadgabaryt'),
    panelPrice: this.translateService.instant('WINDOW|Cena panelu'),
    panelSizes: this.translateService.instant('WINDOW|Rozmiar paneli'),
    panelType: this.translateService.instant('WINDOW|Rodzaj panelu'),
    panelTypes: this.translateService.instant('WINDOW|Rodzaje panelu'),
    perimeter: this.translateService.instant('WINDOW|Obwód'),
    plateType: this.translateService.instant('DOOR|Typ oszyldowania'),
    pleatedBlind: this.translateService.instant('PLEATED_BLIND|Plisa'),
    price: this.translateService.instant('CONFIGURATOR|Cena'),
    price_per_m: this.translateService.instant('CONFIGURATOR|Cena za mb'),
    price_per_q: this.translateService.instant('CONFIGURATOR|Cena za szt.'),
    priceAmount: this.translateService.instant('CONFIGURATOR|Cena jednostkowa'),
    priceId: this.translateService.instant('CONFIGURATOR|Id cennika'),
    priceType: this.translateService.instant('CONFIGURATOR|Typ ceny'),
    profile: this.translateService.instant('ROLLER_SHUTTER_LEGACY|Profil'),
    profile_id: this.translateService.instant('ROLLER_SHUTTER_LEGACY|Id profilu'),
    profiles: this.translateService.instant('MOSQUITO|Profile'),
    pull: this.translateService.instant('DOOR|Typ pochwytu'),
    quantity: this.translateService.instant('CONFIGURATOR|Liczba sztuk'),
    renoFrame: this.translateService.instant('WINDOW|Rama renowacyjna'),
    right: this.translateService.instant('INTERFACE|Prawy'),
    rollerAssembly: this.translateService.instant('ROLLER_SHUTTER_LEGACY|Montaż rolety'),
    rollerBoxes: this.translateService.instant('ROLLER_SHUTTER_LEGACY|Rolety'),
    rollerBoxSize: this.translateService.instant('ROLLER_SHUTTER_LEGACY|Rozmiar skrzynki rolety'),
    rollerShutterMosquito: this.translateService.instant(
        'ROLLER_SHUTTER_LEGACY|Dopłata za siatkę antyinsektową'
    ),
    rollerColor: this.translateService.instant('ROLLER_SHUTTER_LEGACY|Kolor rolety'),
    rollerColors: this.translateService.instant('ROLLER_SHUTTER_LEGACY|Kolory rolety'),
    rollerColorsPercent: this.translateService.instant('ROLLER_SHUTTER_LEGACY|Dopłata procentowa za kolor rolety'),
    rollerConcealedStrip: this.translateService.instant(
        'ROLLER_SHUTTER_LEGACY|Listwa podtynkowa zewnętrzna'
    ),
    rollerConsole: this.translateService.instant('ROLLER_SHUTTER_LEGACY|Konsola rolety'),
    rollerDrive: this.translateService.instant('ROLLER_SHUTTER_LEGACY|Sterowanie rolety'),
    rollerDriveHanger: this.translateService.instant('ROLLER_SHUTTER_LEGACY|Wieszak rolety'),
    rollerDriveElems: this.translateService.instant(
        'ROLLER_SHUTTER_LEGACY|Dodatki do sterowania elektrycznego'
    ),
    rollerDriveManual: this.translateService.instant(
        'ROLLER_SHUTTER_LEGACY|Dodatki do sterowania ręcznego'
    ),
    rollerProfile: this.translateService.instant('ROLLER_SHUTTER_LEGACY|Typ pancerza'),
    rollers: this.translateService.instant('ROLLER_SHUTTER_LEGACY|Rolety'),
    rollerShutterGuideRail: this.translateService.instant('ROLLER_SHUTTER_LEGACY|Prowadnice'),
    rollerShutterSlat: this.translateService.instant('ROLLER_SHUTTER_LEGACY|Listwa końcowa'),
    rollerSlatDivision: this.translateService.instant('ROLLER_SHUTTER_LEGACY|Dopłata za podział pancerza'),
    rollUpPrice: this.translateService.instant('AWNING|Cena falbany zwijanej'),
    sashAccessories: this.translateService.instant('ACCESSORY|Akcesoria do kwater'),
    sashes: this.translateService.instant('WINDOW|Kwatery'),
    sashesHardware: this.translateService.instant('ACCESSORY|Akcesoria do kwater'),
    sashFrames: this.translateService.instant('WINDOW|Skrzydła'),
    sashId: this.translateService.instant('WINDOW|Nr kwatery'),
    sashShape: this.translateService.instant('WINDOW|Kształt kwatery'),
    sashType: this.translateService.instant('WINDOW|Typ kwatery'),
    sealColor: this.translateService.instant('WINDOW|Kolor uszczelki'),
    sideProfile: this.translateService.instant('WINDOW|Poszerzenie'),
    siliconeColor: this.translateService.instant('WINDOW|Kolor silikonu'),
    shape: this.translateService.instant('WINDOW|Kształt'),
    side: this.translateService.instant('INTERFACE|Bok'),
    sideAccessories: this.translateService.instant('ACCESSORY|Akcesoria do krawędzi'),
    size: this.translateService.instant('DIMENSION|Rozmiar'),
    steel: this.translateService.instant('WINDOW|Rodzaj stali'),
    sticked: this.translateService.instant('WINDOW|Naklejane'),
    suppId: this.translateService.instant('CONFIGURATOR|Id dopłaty'),
    system: this.translateService.instant('CONFIGURATOR|System'),
    systemFactors: this.translateService.instant('CONFIGURATOR|Dopłaty procentowe'),
    text_price: this.translateService.instant('AWNING|Cena za tekst'),
    to: this.translateService.instant('INTERFACE|Do'),
    top: this.translateService.instant('INTERFACE|Góra'),
    type: this.translateService.instant('CONFIGURATOR|Rodzaj'),
    typeId: this.translateService.instant('WINDOW|Id rodzaju'),
    typeName: this.translateService.instant('WINDOW|Rodzaj'),
    typeCode: this.translateService.instant('WINDOW|Kod rodzaju'),
    types: this.translateService.instant('WINDOW|Typy'),
    typesSymbol: this.translateService.instant('WINDOW|Typy (symbole)'),
    u: this.translateService.instant('PARAMETER|U'),
    valance: this.translateService.instant('AWNING|Falbana'),
    value: this.translateService.instant('CONFIGURATOR|Wartość'),
    valueType: this.translateService.instant('CONFIGURATOR|Rodzaj wartości'),
    warmEdge: this.translateService.instant('WINDOW|Ciepła ramka'),
    width: this.translateService.instant('DIMENSION|Szerokość'),
    widthOuter: this.translateService.instant('DIMENSION|Szerokość zewn.'),
    windowsill: this.translateService.instant('ACCESSORY|Parapet'),
    wood: this.translateService.instant('WINDOW|Drewno'),
    commodityMultiplier: this.translateService.instant('CONFIGURATOR|Towary'),
    systemMultiplier: this.translateService.instant('CONFIGURATOR|System'),
    supplementMultiplier: this.translateService.instant('CONFIGURATOR|Dopłaty'),
    rollerMultiplier: this.translateService.instant('ROLLER_SHUTTER_LEGACY|Roleta'),
    sashDependencies: this.translateService.instant('WINDOW|Zależności dla skrzydła'),
    dependencies: this.translateService.instant('WINDOW|Zależności dla konstrukcji'),
    keyForMainLockCylinder: this.translateService.instant(
        'DOOR|Cena za dodatkowe klucze do zamka głównego'
    ),
    keyForAdditionalLockCylinder: this.translateService.instant(
        'DOOR|Cena za dodatkowe klucze do zamka dodatkowego'
    ),
    casing: this.translateService.instant('DOOR|Obejma'),
    casingName: this.translateService.instant('DOOR|Nazwa obejmy'),
    casingInnerWidth: this.translateService.instant('DOOR|Wewnętrzna szerokość obejmy'),
    casingWallOverlap: this.translateService.instant('DOOR|Wyłożenie na mur'),
    productFeaturesRaster: this.translateService.instant('CONFIGURATOR|Raster'),
    productFeature: this.translateService.instant('CONFIGURATOR|Atrybutu'),


    externalVenetianRaster: this.translateService.instant('CONFIGURATOR|Raster'),
    externalVenetianLamellaRotation: this.translateService.instant('EXTERNAL_VENETIAN|Obrót lameli'),
    externalVenetianWallMounts: this.translateService.instant('EXTERNAL_VENETIAN|Uchwyty ścienne'),
    externalVenetianTopRailHolders: this.translateService.instant('EXTERNAL_VENETIAN|Uchwyty szyny górnej'),
    externalVenetianBrackets: this.translateService.instant('EXTERNAL_VENETIAN|Wsporniki'),
    externalVenetianGuideHandle: this.translateService.instant('EXTERNAL_VENETIAN|Uchwyt prowadzenia'),
    externalVenetianGuide: this.translateService.instant('EXTERNAL_VENETIAN|Prowadzenie'),
    externalVenetianGuideCap: this.translateService.instant('EXTERNAL_VENETIAN|Zatyczka/zaślepka dolna prowadnicy'),
    externalVenetianGuideInset: this.translateService.instant('EXTERNAL_VENETIAN|Prowadnice z odsadzeniem'),
    externalVenetianBoxPaintedEmbossedProfiles: this.translateService.instant('EXTERNAL_VENETIAN|Malowanie całej skrzynki'),
    externalVenetianCoverSheetPaintedBilateral: this.translateService.instant('EXTERNAL_VENETIAN|Lakierowanie obustronne blachy'),
    externalVenetianCoverColor: this.translateService.instant('EXTERNAL_VENETIAN|Kolor osłony'),
    externalVenetianGuideColor: this.translateService.instant('EXTERNAL_VENETIAN|Kolor prowadnicy'),
    externalVenetianEndRailColor: this.translateService.instant('EXTERNAL_VENETIAN|Kolor listwy dolnej'),
    externalVenetianBoxIncrease: this.translateService.instant('EXTERNAL_VENETIAN|Powiększenie skrzynki'),
    externalVenetianCoverSegments: this.translateService.instant('EXTERNAL_VENETIAN|Blacha osłonowa'),
    externalVenetianBlindSheetExtensions: this.translateService.instant('EXTERNAL_VENETIAN|Przedłużenia blachy'),
    externalVenetianBlindSheetLinks: this.translateService.instant('EXTERNAL_VENETIAN|Łącznik blachy osłonowej'),
    externalVenetianBlindBoxSide: this.translateService.instant('EXTERNAL_VENETIAN|Zaślepka boczna'),
    externalVenetianCrankRod: this.translateService.instant('EXTERNAL_VENETIAN|Trzpień mechanizmu korbowego'),
    externalVenetianCrankGrommet: this.translateService.instant('EXTERNAL_VENETIAN|Przelotka korby'),
    externalVenetianDrive: this.translateService.instant('EXTERNAL_VENETIAN|Napęd'),
    externalVenetianDriveShaftLink: this.translateService.instant('EXTERNAL_VENETIAN|Łącznik wału napędowego'),
    externalVenetianMosquitoScreenType: this.translateService.instant('EXTERNAL_VENETIAN|Moskitiera'),
    externalVenetianRemoteControls: this.translateService.instant('EXTERNAL_VENETIAN|Dodatek do sterowania'),
    externalVenetianBoxMilling: this.translateService.instant('EXTERNAL_VENETIAN|Dopłata za frezowanie skrzynki pod linkę'),
    externalVenetianBoxGuideMilling: this.translateService.instant('EXTERNAL_VENETIAN|Dopłata za frezowanie skrzynki pod prowadnicę'),
    externalVenetianCornerBox: this.translateService.instant('EXTERNAL_VENETIAN|Dopłata do skrzynki narożnej'),
    externalVenetianStaticBracket: this.translateService.instant('EXTERNAL_VENETIAN|Konsola statyczna'),
    externalVenetianInnerPlasterStrip: this.translateService.instant('EXTERNAL_VENETIAN|Listwa tynkowa wewnętrzna'),
    externalVenetianOuterPlasterStrip: this.translateService.instant('EXTERNAL_VENETIAN|Listwa tynkowa zewnętrzna'),
    externalVenetianInnerPlasterStripColor: this.translateService.instant('EXTERNAL_VENETIAN|Kolor listwy tynkowej wewnętrznej'),
    externalVenetianOuterPlasterStripColor: this.translateService.instant('EXTERNAL_VENETIAN|Kolor listwy tynkowej zewnętrznej'),
    externalVenetianBoxConnector: this.translateService.instant('EXTERNAL_VENETIAN|Łącznik między skrzynkami'),
    externalVenetianHorizontalBoxReinforcement: this.translateService.instant('EXTERNAL_VENETIAN|Wzmocnienie skrzynki poziome'),

    // Roller Shutter (new configurator)
    rollerShutterRaster: this.translateService.instant('ROLLER_SHUTTER|Cena bazowa z rastra'),
    rollerShutterColors: this.translateService.instant('ROLLER_SHUTTER|Kolory'),
    rollerShutterProfileColor: this.translateService.instant('ROLLER_SHUTTER|Kolor profilu pancerza'),
    rollerShutterInspectionHatchColor: this.translateService.instant('ROLLER_SHUTTER|Kolor rewizji'),
    rollerShutterEndRailColor: this.translateService.instant('ROLLER_SHUTTER|Kolor listwy dolnej'),
    rollerShutterBoxColor: this.translateService.instant('ROLLER_SHUTTER|Kolor skrzynki'),
    rollerShutterBoxSideColor: this.translateService.instant('ROLLER_SHUTTER|Kolor boczka'),
    rollerShutterGuideColor: this.translateService.instant('ROLLER_SHUTTER|Kolor prowadnic'),
    rollerShutterPlasterStripColor: this.translateService.instant('ROLLER_SHUTTER|Kolor listwy tynkowej'),
    rollerShutterGuideOverlayColor: this.translateService.instant('ROLLER_SHUTTER|Kolor nakładki na prowadnicę'),
    rollerShutterGuides: this.translateService.instant('ROLLER_SHUTTER|Prowadnice'),
    rollerShutterGuide: this.translateService.instant('ROLLER_SHUTTER|Prowadnica'),
    rollerShutterGuideExtension: this.translateService.instant('ROLLER_SHUTTER|Wydłużenie prowadnicy'),
    rollerShutterGuideSpacerStrip: this.translateService.instant('ROLLER_SHUTTER|Listwa dystansowa prowadnicy'),
    rollerShutterGuideChannelCap: this.translateService.instant('ROLLER_SHUTTER|Zaślepka kanału prowadnicy'),
    rollerShutterBox: this.translateService.instant('ROLLER_SHUTTER|Elementy skrzynki'),
    rollerShutterBoxIncrease: this.translateService.instant('ROLLER_SHUTTER|Powiększenie skrzynki'),
    rollerShutterBoxDepthExtension: this.translateService.instant('ROLLER_SHUTTER|Pogłębienie skrzynki'),
    rollerShutterInnerPlasterStrip: this.translateService.instant('ROLLER_SHUTTER|Listwa tynkowa wewnętrzna'),
    rollerShutterOuterPlasterStrip: this.translateService.instant('ROLLER_SHUTTER|Listwa tynkowa zewnętrzna'),
    rollerShutterPlasterStripExtension: this.translateService.instant('ROLLER_SHUTTER|Przedłużenie listwy tynkowej'),
    rollerShutterBoxReinforcement: this.translateService.instant('ROLLER_SHUTTER|Wzmocnienie skrzynki'),
    rollerShutterPolystyreneInsert: this.translateService.instant('ROLLER_SHUTTER|Wkładka styropianowa'),
    rollerShutterBoxAdapter: this.translateService.instant('ROLLER_SHUTTER|Adapter do skrzynki'),
    rollerShutterAdapterReinforcement: this.translateService.instant('ROLLER_SHUTTER|Wzmocnienie adaptera/trawersy'),
    rollerShutterDrives: this.translateService.instant('ROLLER_SHUTTER|Napędy'),
    rollerShutterDrive: this.translateService.instant('ROLLER_SHUTTER|Napęd'),
    rollerShutterRemoteControls: this.translateService.instant('ROLLER_SHUTTER|Akcesoria do sterowania'),
    rollerShutterAccessories: this.translateService.instant('ROLLER_SHUTTER|Akcesoria'),
    rollerShutterStaticBracket: this.translateService.instant('ROLLER_SHUTTER|Konsola statyczna'),
    rollerShutterSteelMountingAnchor: this.translateService.instant('ROLLER_SHUTTER|Kotwa montażowa stalowa'),
    rollerShutterBoxWidthExtension: this.translateService.instant('ROLLER_SHUTTER|Przedłużenie szerokości skrzynki'),
    rollerShutterInspectionHatchBracket: this.translateService.instant('ROLLER_SHUTTER|Wspornik rewizji'),
    rollerShutterSnapPlate: this.translateService.instant('ROLLER_SHUTTER|Płyta zatrzaskowa'),
    rollerShutterMountingBracket: this.translateService.instant('ROLLER_SHUTTER|Uchwyt montażowy'),
    rollerShutterBoxSideCap: this.translateService.instant('ROLLER_SHUTTER|Zaślepka boczna skrzynki'),
    rollerShutterBoxSideInsulation: this.translateService.instant('ROLLER_SHUTTER|Izolacja boków skrzynki'),
    rollerShutterSets: this.translateService.instant('ROLLER_SHUTTER|Komplety'),
    rollerShutterSteelSideBracket: this.translateService.instant('ROLLER_SHUTTER|Stalowy uchwyt boczny'),
    rollerShutterBlockHanger: this.translateService.instant('ROLLER_SHUTTER|Wieszak blokady'),
    rollerShutterSecurityBolt: this.translateService.instant('ROLLER_SHUTTER|Rygiel'),
    rollerShutterMosquitoRolled: this.translateService.instant('ROLLER_SHUTTER|Moskitiera rolowana'),
    rollerShutterMosquitoEndRailColor: this.translateService.instant('ROLLER_SHUTTER|Kolor listwy dolnej moskitiery'),
    rollerShutterDriveShaftLink: this.translateService.instant('ROLLER_SHUTTER|Wspólny napęd rolety'),


    // Pleated Mosquito Screen
    pleatedMosquitoScreenRaster: this.translateService.instant('PLEATED_MOSQUITO_SCREEN|Moskitiera plisowana - raster'),
    pleatedMosquitoScreenColors: this.translateService.instant('PLEATED_MOSQUITO_SCREEN|Kolory'),
    pleatedMosquitoScreenProfileColor: this.translateService.instant('PLEATED_MOSQUITO_SCREEN|Kolor profili moskitiery'),
};
locale(elems: any): string {
    let elemsString = JSON.stringify(elems);
    let re;
    if (Common.isArray(elems)) {
        for (const k in this.dictionary) {
            re = new RegExp('"' + k + '"', 'g');
            elemsString = elemsString.replace(
                re,
                '"' + this.dictionary[k as keyof PriceDictionaryService['dictionary']] + '"'
            );
            re = new RegExp('"data.' + k + '"', 'g');
            elemsString = elemsString.replace(
                re,
                '"' + this.dictionary[k as keyof PriceDictionaryService['dictionary']] + '"'
            );
        }

        return JSON.parse(elemsString);
    } else if (isObject(elems)) {
        for (const k in this.dictionary) {
            re = new RegExp('"' + k + '":', 'g');
            elemsString = elemsString.replace(
                re,
                '"' +
                    this.dictionary[k as keyof PriceDictionaryService['dictionary']].trim() +
                    '":'
            );
        }
        return JSON.parse(elemsString);
    } else if (isString(elems)) {
        if (Object.prototype.hasOwnProperty.call(this.dictionary, elems)) {
            return this.dictionary[elems];
        }
    }
    return elems;
  }
}
